import { Injectable } from '@angular/core';
import { NgxImageCompressService } from 'ngx-image-compress';

@Injectable({
  providedIn: 'root',
})
export class ImageCompressServiceWrapper {
  constructor(private readonly ngxImageCompressService: NgxImageCompressService) { }

  async compressImage(file: File): Promise<File> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async (event: any) => {
        const compressedImage = await this.ngxImageCompressService.compressFile(event.target.result, 1, 100, 60, 1300, 1000);
        const blob = this.dataURItoBlob(compressedImage);
        const newFile = new File([blob], file.name, { type: file.type });
        resolve(newFile);
      };
      reader.onerror = () => reject(new Error('File reading error'));
    });
  }

  private dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const arrayBuffer = new Uint8Array(byteString.length);

    for (let i = 0; i < byteString.length; i++) {
      arrayBuffer[i] = byteString.charCodeAt(i);
    }

    return new Blob([arrayBuffer], { type: mimeString });
  }
}
